// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"77184ccc","147":"488ca8cd","737":"4ea9ec12","836":"78d6d730","940":"86805d7e"}[chunkId] + ".chunk.js";
};